module.exports = __webpack_public_path__ + "0462568ef6e997f9bd6def7ea88eacf1.svg";